import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import ErrorFallback from 'components/Shared/ErrorFallback'
import AttributionModel from './AttributionModel'
import Billing from './Billing'
import SetupMFASetting from './SetupMFASetting'
import DataIntegrations from './DataIntegrations'
import CoCreatePromt from './CoCreatePromt'

export default function SystemSettings() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <>
        <div className="settings-page__section">
          <AttributionModel />
        </div>

        <div className="settings-page__section">
          <CoCreatePromt />
        </div>

        <div className="settings-page__section">
          <Billing />
        </div>

        <div className="settings-page__section">
          <SetupMFASetting />
        </div>

        <div className="settings-page__section">
          <DataIntegrations />
        </div>
      </>
    </ErrorBoundary>
  )
}
